import { AuthService } from '@auth0/auth0-angular';
import { SIGNED_OUT_PATH } from './signed-out-utils';
import { announceSession } from '../../services/session-sync.service';

/** Logs out of Auth0 completely and lands on the signed-out page; clearing localStorage also ends any impersonation. */
export function signOut(authService: AuthService, clientId: string): void {
  sessionStorage.clear();
  localStorage.clear();
  // The other tabs share the login that was just cleared: they go to the signed-out page now instead of on their next click
  announceSession('signed-out');
  // Subscribe: the returned observable is what triggers the logout redirect in some auth0-angular versions.
  authService
    .logout({
      logoutParams: {
        federated: true,
        clientId,
        returnTo: `${window.location.origin}${SIGNED_OUT_PATH}?reason=logout`,
      },
    })
    .subscribe();
}
